import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Nav/nav';
import a11yStyles from '@patternfly/react-styles/css/utilities/Accessibility/accessibility';
import { css } from '@patternfly/react-styles';
import AngleRightIcon from '@patternfly/react-icons/dist/js/icons/angle-right-icon';
import { getUniqueId } from '../../helpers/util';
import { NavContext } from './Nav';
export var NavExpandable =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NavExpandable, _React$Component);

  function NavExpandable() {
    var _this;

    _classCallCheck(this, NavExpandable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NavExpandable).apply(this, arguments));
    _this.expandableRef = React.createRef();
    _this.id = _this.props.id || getUniqueId();
    _this.state = {
      expandedState: _this.props.isExpanded
    };

    _this.onExpand = function (e, val) {
      if (_this.props.onExpand) {
        _this.props.onExpand(e, val);
      } else {
        _this.setState({
          expandedState: val
        });
      }
    };

    _this.handleToggle = function (e, onToggle) {
      // Item events can bubble up, ignore those
      if (!_this.expandableRef.current || !_this.expandableRef.current.contains(e.target)) {
        return;
      }

      var groupId = _this.props.groupId;
      var expandedState = _this.state.expandedState;
      onToggle(e, groupId, !expandedState);

      _this.onExpand(e, !expandedState);
    };

    return _this;
  }

  _createClass(NavExpandable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        expandedState: this.props.isExpanded
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isExpanded !== prevProps.isExpanded) {
        this.setState({
          expandedState: this.props.isExpanded
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          id = _a.id,
          title = _a.title,
          srText = _a.srText,
          children = _a.children,
          className = _a.className,
          isActive = _a.isActive,
          groupId = _a.groupId,
          isExpanded = _a.isExpanded,
          onExpand = _a.onExpand,
          props = __rest(_a, ["id", "title", "srText", "children", "className", "isActive", "groupId", "isExpanded", "onExpand"]);

      var expandedState = this.state.expandedState;
      return React.createElement(NavContext.Consumer, null, function (context) {
        return React.createElement("li", Object.assign({
          className: css(styles.navItem, expandedState && styles.modifiers.expanded, isActive && styles.modifiers.current, className),
          onClick: function onClick(e) {
            return _this2.handleToggle(e, context.onToggle);
          }
        }, props), React.createElement("a", {
          ref: _this2.expandableRef,
          className: styles.navLink,
          id: srText ? null : _this2.id,
          href: "#",
          onClick: function onClick(e) {
            return e.preventDefault();
          },
          onMouseDown: function onMouseDown(e) {
            return e.preventDefault();
          },
          "aria-expanded": expandedState
        }, title, React.createElement("span", {
          className: css(styles.navToggle)
        }, React.createElement("span", {
          className: css(styles.navToggleIcon)
        }, React.createElement(AngleRightIcon, {
          "aria-hidden": "true"
        })))), React.createElement("section", {
          className: css(styles.navSubnav),
          "aria-labelledby": _this2.id,
          hidden: expandedState ? null : true
        }, srText && React.createElement("h2", {
          className: css(a11yStyles.screenReader),
          id: _this2.id
        }, srText), React.createElement("ul", {
          className: css(styles.navList)
        }, children)));
      });
    }
  }]);

  return NavExpandable;
}(React.Component);
NavExpandable.defaultProps = {
  srText: '',
  isExpanded: false,
  children: '',
  className: '',
  groupId: null,
  isActive: false,
  id: ''
};